import React from 'react';
import './OurTeam.css';
import FadeUp from "../FadeUp/FadeUp";

const OurTeam = ({ isAlbanian }) => {
  return (
    <div>
      <div className="ourteam-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
            <div className='ourteam-content'>
              <div className='ourteam-left'>
            <div className='ourteam-title'>
            <FadeUp>
          {isAlbanian ? 'Ekipi ynë' : 'Our Team'}
          </FadeUp>
            </div>
            </div>
              <div className='ourteam-right'>
              <h2>
              <FadeUp>
              {isAlbanian
                ? 'Ekipi ynë përbëhet nga një staf i gjerë, nga specialistë me përvojë deri te punëtorët e thjeshtë. Një nga objektivat kryesorë të kompanisë është investimi tek punonjësit tanë, duke u siguruar atyre një mjedis pune të sigurt dhe vlerësim të vazhdueshëm.'
                : 'Our team consists of a broad staff, ranging from experienced specialists to general workers. One of the company’s main objectives is investing in our employees, ensuring them a safe work environment and continuous recognition.'}
              <br />
              </FadeUp>
            </h2>
              </div>
            </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
